export enum DialogType {
  JustText = 'JustText',
  Accept = 'Accept',
  ConfirmCancel = 'ConfirmCancel',
  Acknowledge = 'Acknowledge',
  Update = 'Update',
  Yes = 'Yes',
}
